import React from 'react';
import {
  Box,
  Button,
  // Container,
  // Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import RemindersMsconReceivedActions from '../../redux/reducers/reminders_mscon_received_list_reducer/actions';
import useStyles from './styles';
import RemindersMsconReceivedDatatableList from './components/datatable';
import clsx from 'clsx';
import NotificationImportantOutlinedIcon from '@material-ui/icons/NotificationImportantOutlined';
import { Translations } from './configuration';
import { RemindersMsconReceivedTableDefaultFetchValues } from './components/datatable/configuration';
import NavigationConfig from 'navigation/config';
import RemindersMsconReceivedListActions from 'redux/reducers/reminders_mscon_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';

const RemindersMsconReceivedPage = (props: any) => {
  // console.log('Render RemindersMsconReceived Page');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(
      RemindersMsconReceivedListActions.fetchMemberStateExcludeCyprusAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      RemindersMsconReceivedActions.fetchUnreadNotificationCountAction()
    );
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      RemindersMsconReceivedActions.fetchRemindersMsconReceivedListAction({
        sortField:
          RemindersMsconReceivedTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: RemindersMsconReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize:
          RemindersMsconReceivedTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order:
          RemindersMsconReceivedTableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== RemindersMsconReceived Page ==================*/
    <div>
      {/*================== RemindersMsconReceived Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* RemindersMsconReceived Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <NotificationImportantOutlinedIcon
            style={{ marginRight: '.75rem' }}
          />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of RemindersMsconReceived Page - Header ---------------*/}

      {/*================== RemindersMsconReceived Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== RemindersMsconReceived Page - Body - RemindersMsconReceived Section ==================*/}
        <div className={classes.cardLayout}>
          {/* RemindersMsconReceived Page - Body - RemindersMsconReceived Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* RemindersMsconReceived Page - Body - RemindersMsconReceived Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* RemindersMsconReceived Page - Body - RemindersMsconReceived Section - RemindersMsconReceived List Table */}
          <div className={classes.tableList}>
            <RemindersMsconReceivedDatatableList />
          </div>

          {/* RemindersMsconReceived Page - Body - RemindersMsconReceived Section - Buttons & Actions */}
          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of RemindersMsconReceived Page - Body - RemindersMsconReceived Section ---------------*/}
      </div>
      {/*--------------- end of RemindersMsconReceived Page - Body ---------------*/}
    </div>
    /*--------------- end of RemindersMsconReceived Page ---------------*/
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(RemindersMsconReceivedPage);
